import { defineComponent as K, getCurrentInstance as L, ref as v, computed as U, inject as q, watch as G, watchEffect as H, createElementBlock as B, openBlock as r, Fragment as J, createBlock as l, createCommentVNode as n, mergeProps as D, unref as t, createVNode as O, normalizeClass as M, withCtx as s, renderSlot as b, createTextVNode as R, toDisplayString as E, Teleport as I, withDirectives as Q, vShow as W } from "vue";
import f from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Tabs/tabs.js";
import { TabsProvideKey as X, TabsKey as Y } from "./common.js";
import Z from "./TabTitleIcon.vue2.js";
import _ from "./TabTitleText.vue2.js";
import x from "./TabButton.vue2.js";
import ee from "./TabContent.vue2.js";
import te from "../Menu/MenuItem.vue2.js";
import { useChildrenTracker as ae } from "../../use/children-tracker.js";
import { useOUIAProps as oe } from "../../helpers/ouia.js";
const pe = /* @__PURE__ */ K({
  name: "PfTab",
  inheritAttrs: !1,
  __name: "Tab",
  props: {
    title: {},
    href: {},
    target: {},
    disabled: { type: Boolean },
    ariaDisabled: { type: Boolean },
    contentRef: {},
    mountOnEnter: { type: Boolean },
    unmountOnExit: { type: Boolean },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  emits: ["click", "enter", "leave"],
  setup(P, { expose: A, emit: N }) {
    const d = P, V = oe({ id: d.ouiaId, safe: d.ouiaSafe }), m = N, c = L(), k = v(), j = Symbol(), a = U(() => (c == null ? void 0 : c.vnode.key) ?? j), o = q(X), y = v(!1);
    ae(Y, {
      key: a,
      el: k,
      overflowing: y
    });
    const i = o == null ? void 0 : o.activeKey, $ = o == null ? void 0 : o.tabOverflowRef, g = o == null ? void 0 : o.contentTargetRef, p = o == null ? void 0 : o.idSuffix, u = v(!1);
    G([a, i], () => {
      a.value === (i == null ? void 0 : i.value) ? (u.value = !0, m("enter")) : u.value && (d.unmountOnExit && (u.value = !1), m("leave"));
    }, { immediate: !0 }), H(() => {
      const e = d.contentRef;
      e && (e.hidden = a.value !== (i == null ? void 0 : i.value));
    });
    function z(e) {
      i && (i.value = a.value), m("click", e);
    }
    return A({
      key: a
    }), (e, h) => {
      var S, C, T, w;
      return r(), B(J, null, [
        y.value ? (C = (S = t($)) == null ? void 0 : S.$.exposed) != null && C.el ? (r(), l(I, {
          key: 1,
          to: (w = (T = t($)) == null ? void 0 : T.$.exposed) == null ? void 0 : w.el
        }, [
          O(te, null, {
            default: s(() => [
              R(E(e.title), 1)
            ]),
            _: 1
          })
        ], 8, ["to"])) : n("", !0) : (r(), B("li", D({
          key: 0,
          ref_key: "el",
          ref: k
        }, t(V), {
          class: [t(f).tabsItem, {
            [t(f).modifiers.current]: a.value === t(i)
          }]
        }), [
          O(x, {
            id: `pf-tab-${typeof a.value == "symbol" ? a.value.description ?? "" : a.value}-${String(t(p))}`,
            class: M([t(f).tabsLink, {
              [t(f).modifiers.disabled]: e.disabled && e.href,
              [t(f).modifiers.ariaDisabled]: e.ariaDisabled
            }]),
            href: e.href,
            target: e.target,
            disabled: e.disabled && !e.href,
            tabindex: (e.disabled || e.ariaDisabled) && e.href ? -1 : void 0,
            "aria-disabled": e.disabled || e.ariaDisabled,
            "aria-controls": `pf-tab-section-${String(a.value)}-${String(t(p))}`,
            "aria-selected": t(i) === a.value,
            role: "tab",
            onClick: h[0] || (h[0] = (F) => z(F))
          }, {
            default: s(() => [
              e.$slots.icon ? (r(), l(Z, { key: 0 }, {
                default: s(() => [
                  b(e.$slots, "icon")
                ]),
                _: 3
              })) : n("", !0),
              b(e.$slots, "title", {}, () => [
                e.title ? (r(), l(_, { key: 0 }, {
                  default: s(() => [
                    R(E(e.title), 1)
                  ]),
                  _: 1
                })) : n("", !0)
              ])
            ]),
            _: 3
          }, 8, ["id", "class", "href", "target", "disabled", "tabindex", "aria-disabled", "aria-controls", "aria-selected"])
        ], 16)),
        t(g) && !e.contentRef ? (r(), l(I, {
          key: 2,
          to: t(g)
        }, [
          !e.mountOnEnter || u.value ? Q((r(), l(ee, D({
            id: `pf-tab-section-${String(a.value)}-${String(t(p))}`,
            key: a.value
          }, e.$attrs), {
            default: s(() => [
              b(e.$slots, "default")
            ]),
            _: 3
          }, 16, ["id"])), [
            [W, a.value === t(i)]
          ]) : n("", !0)
        ], 8, ["to"])) : n("", !0)
      ], 64);
    };
  }
});
export {
  pe as default
};
